export default "__VITE_PUBLIC_ASSET__8a838023__"